import template from './recapResponseFormResponse.html';
import controller from './recapResponseFormResponse.controller';

let formComponent = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    formResponseSet: '<',
    formResponse: '<',
    formIndex: '<',
  }
};

export default formComponent;
